module.exports = __webpack_public_path__ + "static/media/livee-white.65376456.png";